import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import AdvanceInvoiceForm from "./pages/AdvanceInvoiceForm";
import FinalInvoiceForm from "./pages/FinalInvoiceForm";
import InvoiceDetail from "./pages/InvoiceDetail";
import SettingsPage from "./pages/Settings";
import Manual from "./pages/Manual";
import SearchTrips from "./pages/SearchTrips";
import CostControl from "./pages/CostControl";
import Adjustments from "./pages/Adjustments";
import CerradoTerminado from "./pages/CerradoTerminado";
import AdvancesByYear from "./pages/AdvancesByYear";
import { LoginPage, AuthCallback, ProtectedRoute } from "./pages/Auth";
import { getInvoice } from "./lib/api";

function EditRouterWrapper() {
  const { id } = useParams();
  const [type, setType] = useState(null);
  useEffect(() => {
    getInvoice(id).then((i) => setType(i.type)).catch(() => setType("advance"));
  }, [id]);
  if (!type) return <div className="text-slate-400">Cargando...</div>;
  if (type === "advance") return <AdvanceInvoiceForm />;
  return <FinalInvoiceForm />;
}

// Synchronous detection of session_id in URL fragment to handle OAuth callback
// BEFORE any other route logic runs (prevents race with ProtectedRoute).
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="nueva/adelanto" element={<AdvanceInvoiceForm />} />
        <Route path="nueva/final" element={<FinalInvoiceForm />} />
        <Route path="factura/:id" element={<InvoiceDetail />} />
        <Route path="factura/:id/editar" element={<EditRouterWrapper />} />
        <Route path="ajustes" element={<SettingsPage />} />
        <Route path="manual" element={<Manual />} />
        <Route path="manual/:slug" element={<Manual />} />
        <Route path="buscar" element={<SearchTrips />} />
        <Route path="costes" element={<CostControl />} />
        <Route path="ajustes-importes" element={<Adjustments />} />
        <Route path="cerrado-terminado" element={<CerradoTerminado />} />
        <Route path="adelantos-por-ano" element={<AdvancesByYear />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-plex">
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
